import { useEffect, useRef } from 'react'

const useFocusTextarea = (autoFocus?: boolean) => {
  const textFieldRef = useRef<HTMLTextAreaElement | HTMLInputElement | null>(
    null,
  )

  const focusTextArea = (): void => textFieldRef.current?.focus()

  useEffect(() => {
    if (!autoFocus) return

    const timeId = setTimeout(focusTextArea, 0)

    return () => clearTimeout(timeId)
  }, [autoFocus])

  return [textFieldRef, focusTextArea] as const
}

export default useFocusTextarea
